import isArray from 'lodash/isArray';

export const mapBytesToKb = (size: number) => `${Math.round(size / 1024)}Kb`;

export const getInitialValue = (value?: File | File[]): File[] => {
  value = value || [];

  return isArray(value) ? value : [value];
};
